'use client';

import Empty from '@/components/empty/Empty';
import ErrorComponent from '@/components/empty/ErrorComponent';
import Loading from '@/components/common/loading/Loading';
import useLeaderBySlug from '@/utils/hooks/useLeaderBySlug';
import Profile from '../../profile/Profile';

type LeaderProfileProps = {
  leaderSlug: string;
};

const LeaderProfileContainer = ({ leaderSlug }: LeaderProfileProps) => {
  const { data, isLoading, isError } = useLeaderBySlug(leaderSlug);
  const leaderData = data ? data[0] : {};

  if (isError) {
    return (
      <div className='min-h-[400px] flex justify-center items-center'>
        <ErrorComponent />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className='min-h-[400px] flex justify-center items-center'>
        <Loading />
      </div>
    );
  }

  if (data?.length === 0) {
    return (
      <Empty title='Profile unavailable' microcopy='Please check back later' />
    );
  }

  return (
    <Profile
      name={leaderData?.name ?? ''}
      position={leaderData?.position ?? ''}
      imgAlt={leaderData?.name ?? ''}
      imgSrc={leaderData?.image?.asset?.url ?? ''}
      biography={leaderData?.biographyRaw}
    />
  );
};

export default LeaderProfileContainer;
